import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LoaderService {
	// private isLoading = new BehaviorSubject<boolean>(false);
	// isLoading$ = this.isLoading.asObservable();

	private activeRequests = 0; // Contador de solicitudes activas

	show() {
		// this.activeRequests++;
		// if (this.activeRequests === 1) {
		// 	this.isLoading.next(true); // Mostrar el loader solo si es la primera solicitud
		// }
	}

	hide() {
		// this.activeRequests--;
		// if (this.activeRequests === 0) {
		// 	this.isLoading.next(false); // Ocultar el loader cuando no hay solicitudes activas
		// }
	}
}
